export const eventTypesById = {
    1: 'TOURNAMENT',
    2: 'LEAGUE_OR_TEAM',
    3: 'GENERAL',
    4: 'FREE_PLAY',
    5: 'CAMP',
    6: 'CLINIC',
    7: 'MATCH_PLAY',
    8: 'DUAL_MATCH',
    9: 'NON_TENNIS', // obsolete
    10: 'VIRTUAL', // obsolete
    11: 'FLEX_LEAGUE',
    12: 'TEAM_LEAGUE',
    13: 'TEAM_MATCH',
    14: 'PAID_HIT',
};

export const eventStateTypeIds = {
    PRE_REGISTRATION: 1,
    OPEN_REGISTRATION: 2,
    REGISTRATION_CLOSED: 3,
    IN_PROGRESS: 4,
    COMPLETED: 5,
};

export const registrationStateTypeIds = {
    PRE_REGISTRATION: 1,
    OPEN_REGISTRATION: 2,
    REGISTRATION_CLOSED: 3,
};

export const acceptanceValues = {
    LIST: 'LIST',
    WAIT_LIST: 'WAIT_LIST',
    CAPPED_REGISTRATION: 'CAPPED_REGISTRATION',
};

export const acceptanceRankingValues = {
    PTT: 'PTS',
    UTR: 'UTR',
    WTA: 'WTA',
};

export const acceptanceBucketTypes = {
    MAIN: 'MAIN',
    QUALIFYING: 'QUALIFYING',
    ALTERNATE: 'ALTERNATE',
    WITHDRAWN: 'WITHDRAWN',
};

export const acceptanceBucketTypeLabels = {
    MAIN: 'Main',
    QUALIFYING: 'Qualifying',
    ALTERNATE: 'Alternate',
    WITHDRAWN: 'Withdrawn',
};
export const acceptanceBucketTypeSortKey = {
    MAIN: 1,
    QUALIFYING: 2,
    ALTERNATE: 3,
    WITHDRAWN: 4,
};

export const acceptanceBucketTypeIds = {
    1: 'Main',
    2: 'Qualifying',
    3: 'Alternate',
    4: 'Withdrawn',
};

export const waitlistBucketTypes = {
    MAIN: 'MAIN',
    WAITLIST: 'WAITLIST',
    NEED_PARTNER: 'NEED_PARTNER',
    WITHDRAWN: 'WITHDRAWN',
};

export const waitlistBucketTypeLabels = {
    MAIN: 'Main',
    WAITLIST: 'Waitlist',
    NEED_PARTNER: 'Need partner',
    WITHDRAWN: 'Withdrawn',
};

export const waitlistBucketTypeSortKey = {
    MAIN: 1,
    WAITLIST: 2,
    NEED_PARTNER: 3,
    WITHDRAWN: 4,
};

export const waitlistBucketTypeIds = {
    1: 'Main',
    2: 'Waitlist',
    3: 'Need partner',
    4: 'Withdrawn',
};

export const needsPartnerText = 'Need Partner';

export const SpecialExemptOptions = [0, 1, 2];

export const passwordForDisplay = '***********';

export const maxUtrRatingDiffInDraw = 2;

export const allDivisions = 'All Divisions';

export const freeDivision = 'Free';

export const withDrawnForDisplay = 'WITHDRAWN';

export const waitlistForDisplay = 'WAITLIST';

export const allStatusesForDisplay = 'All statuses';

export const allPositionsForDisplay = 'All positions';

export const mainPositionForDisplay = 'MAIN';

export const needsPartnerForDisplay = 'NEED_PARTNER';

export const singleDivision = 1;

export const EventVerifiedTypes = {
    UnVerified: 1,
    Sanctioned: 2,
};

export const EventAttachmentMediaTypes = {
    FILE: 'file',
    LINK: 'link',
};

export const EventHsTypes = {
    OFFICIAL: 1,
    OTHER: 2,
};

export const bucketWildcardTags = {
    1: '',
    2: 'MWC',
    3: 'QWC',
    4: 'SE',
};

export const drawPlayerTags = {
    1: 'Q',
    2: 'LL',
    3: 'ALT',
    4: 'WC',
};

export const DefaultTimeZone = 77;

export const divisionGenderTypes = {
    ALL: 'all',
    MALE: 'm',
    FEMALE: 'f',
    MIXED: 'mixed',
};

export const eventGenderTypeIds = {
    ALL: 1,
    MALE: 2,
    FEMALE: 3,
    MIXED: 4,
};
export const eventFormatTypeIds = {
    SINGLES: 1,
    DOUBLES: 2,
};
export const divisionFormatTypeIds = {
    SINGLES: 1,
    DOUBLES: 2,
    DINGLES: 3,
};

export const drawAutofillTypeIds = {
    LEVEL_BASED: 1,
    SNAKE: 2,
    SEEDED: 3,
};

export const drawEliminationTypeIds = {
    SINGLE_ELIMINATION: 1,
    FIRST_MATCH_BACKDRAW: 2,
    ROUND_ROBIN: 3,
    COMPASS: 4,
    MATCH_PLAY: 5,
    AD_HOC: 6,
    DOUBLE_ELIMINATION: 7,
    FEED_IN_CONSOLATION: 8,
    FEED_IN_BACK_DRAW: 9,
    FLEX_LEAGUE: 101, // only exists on client side
    PRO_DRAWS: 102, // only exists on client side
};

export const drawEliminationTypes = {
    ROUND_ROBIN: 'round_robin',
    AD_HOC: 'ad_hoc',
    SINGLE_ELIMINATION: 'single_elimination',
    DOUBLE_ELIMINATION: 'double_elimination',
    FEED_IN_CONSOLATION: 'feed_in_consolation',
    MATCH_PLAY: 'match_play',
    PRO_DRAW: 'pro_draw',
    PRO_DRAW_QUALIFIER: 'pro_draw_qualifier',
    FIRST_MATCH_BACKDRAW: 'first_match_backdraw',
    FEED_IN_BACKDRAW: 'feed_in_backdraw',
};

export const drawEliminationLabels = {
    SINGLE_ELIMINATION: 'Single Elimination',
    FIRST_MATCH_BACKDRAW: 'First Match Backdraw',
    ROUND_ROBIN: 'Round Robin',
    COMPASS: 'Compass',
    MATCH_PLAY: 'Match Play',
    AD_HOC: 'Ad-Hoc',
    DOUBLE_ELIMINATION: 'Double Elimination',
    FEED_IN_CONSOLATION: 'Feed-in Consolation',
    FEED_IN_BACK_DRAW: 'Feed-in Backdraw',
};

export const positionTypes = {
    BYE: 'bye',
    PLAYER: 'player',
    TEAM: 'team',
};

export const utrTypeIds = {
    MYUTR: 1,
    SANCTIONED: 2,
};

export const utrTypes = {
    MYUTR: 'myutr',
    SANCTIONED: 'sanctioned',
};

export const drawCategoryTypeIds = {
    MAIN: 1,
    BACK_DRAW: 2,
    QUALIFYING: 3,
    COMPASS_EAST: 4,
    COMPASS_WEST: 5,
    COMPASS_NORTH: 6,
    COMPASS_SOUTH: 7,
    COMPASS_NORTHWEST: 8,
    COMPASS_NORTHEAST: 9,
    COMPASS_SOUTHWEST: 10,
    COMPASS_SOUTHEAST: 11,
    GROUPED: 12,
    CONSOLATION: 13,
    THREEFOURPLAYOFF: 14,
    FIVESIXPLAYOFF: 15,
    AUTO_PLAYOFF: 16,
    PRO_DRAW: 17,
    PRO_DRAW_QUALIFIER: 18,
};

export const drawCategoryTypes = {
    MAIN: 'main',
    CONSOLATION: 'consolation',
};

export const drawPlacementStatusTypeIds = {
    PLACED: 1,
    NOT_PLACED: 2,
    WAITLIST: 3,
};

export const drawScheduleTypeIds = {
    MATCH_SHEET: 1,
    ORDER_OF_PLAY: 2,
    NEXT_AVAILABLE: 3,
};

export const drawScheduleTypeLabels = {
    1: {
        title: 'Match Sheets',
        inline: 'match sheets',
    },
    2: {
        title: 'Order of Play',
        inline: 'order of play',
    },
    3: {
        title: 'Next Available',
        inline: 'next available',
    },
};

export const drawPositionTypeIds = {
    PLAYER: 1,
    TEAM: 2,
    BYE: 3,
};

export const drawPermissionTypeIds = {
    ORGANIZER: 1,
    SELFONLY: 2,
    PLAYERPOST: 3,
};
export const ballTypeIds = {
    YELLOW: -1,
    RED: 0,
    ORANGE: 1,
    GREEN: 2,
};

export const ballTypeValues = {
    YELLOW: 'Yellow',
    RED: 'Red',
    ORANGE: 'Orange',
    GREEN: 'Green',
};

export const ballTypes = [
    {
        id: -1,
        label: 'Yellow Ball',
        value: 'Yellow',
    },
    {
        id: 2,
        label: 'Green Ball',
        value: 'Green',
    },
    {
        id: 1,
        label: 'Orange Ball',
        value: 'Orange',
    },
    {
        id: 0,
        label: 'Red Ball',
        value: 'Red',
    },
];

export const clubStatusTypeIds = {
    PENDING: 1,
    ACTIVE: 2,
    OVERDUE: 3,
    SUSPENDED: 4,
    REVOKED: 5,
    PAYMENT_REQUIRED: 6,
};

export const paymentProviderTypeIds = {
    WEPAY: 1,
    STRIPE: 2,
    PAYPAL: 3,
};

export const clubJoinRequestTypeIds = {
    NONE: 1,
    JOIN: 2,
};

export const paymentStatusTypeIds = {
    PENDING: 1,
    REFUNDED: 2,
    FREE: 3,
    PAID: 4,
    FAILED: 5,
    WAITING: 6,
    REFUNDING: 7,
};

export const registrationStatusTypeIds = {
    ACTIVE: 1,
    WITHDRAWN: 2,
    REGISTERED: 3,
    CREATED: 4, // PENDING
    PENDING: 4,
    PAYMENT_FAILED: 5,
};

export const registrationStatusTypes = {
    2: 'WITHDRAWN',
    3: 'REGISTERED',
    4: 'PENDING',
};

export const divisionRegistrationTypeIds = {
    ADMIN_ADD_FREE: 1,
    ADMIN_ADD_PAYMENT_REQUIRED: 2,
};

export const divisionRegistrationTypes = {
    1: 'AdminAddFree',
    2: 'AdminAddPaymentRequired',
};

export const directorRoleIds = {
    ADMIN: 1,
    OWNER: 2,
    VOLUNTEER: 3,
};

export const clubMemberRoleIds = {
    OWNER: 1,
    ADMIN: 2,
    MEMBER: 3,
    FORMER_MEMBER: 4,
    BANNED: 5,
    FOLLOWER: 6,
    FORMER_FOLLOWER: 7,
};

export const EventScheduleTypes = {
    RECENT: 'recent',
    UPCOMING: 'upcoming',
    INPROGRESS: 'inprogress',
};

export const TmsEventUsapApplicationStatusTypes = {
    PENDING: 1,
    APPROVED: 2,
    DECLINED: 3,
};

export const TmsEventUsapVerificationTypes = {
    MEDAL_MATCH_PLUS: 1,
    STANDARD: 2,
    NO_REFEREE: 3,
};

export const LeagueGenderTypeIds = {
    CO_ED: 1,
    MALE: 2,
    FEMALE: 3,
};

export const LeagueGenderValues = {
    ALL: '',
    CO_ED: 'Co-ed',
    MALE: 'M',
    FEMALE: 'F',
    MIXED: 'Mixed',
};

export const sportTypeIds = {
    TENNIS: 1,
    PICKLEBALL: 2,
};

export const officialsTypeIds = {
    NO: 1,
    YES: 2,
};

export const coachingTypeIds = {
    NO: 1,
    YES: 2,
};

export const referralInviteTypeIds = {
    FLEX_LEAGUE_REFERRAL: 1,
};

export const feedInBackDrawFormatOptions = [
    {
        id: 1,
        label: 'Round 1',
        value: 1,
    },
    {
        id: 2,
        label: 'Round 2',
        value: 2,
    },
];

export const ficFormatTypeIds = [
    {
        id: 1,
        label: 'FIC to Rd 16',
        value: 'FIC-16',
    },
    {
        id: 2,
        label: 'FIC to QF',
        value: 'FIC-QF',
    },
];

export const ficFormatTypeIdsDisabledFIC16 = [
    {
        id: 1,
        label: 'FIC to Rd 16',
        value: 'FIC-16',
        disabled: true,
    },
    {
        id: 2,
        label: 'FIC to QF',
        value: 'FIC-QF',
    },
];

export const ficFormats = {
    FIC_16: 1,
    FIC_QF: 2,
};

export const matchCounts = {
    FINAL: 1,
    SEMI_FINAL: 2,
    QUARTER_FINAL: 4,
};

export const teamPaymentTypeIds = {
    PAY_AS_A_TEAM: 1,
    PAY_SEPARATELY: 2,
};

export const acceptanceTypeIds = {
    WAIT_LIST: 1,
    CAPPED_REGISTRATION: 2,
    LIST: 3,
};

export const acceptanceCriteriaList = [
    {
        id: acceptanceTypeIds.WAIT_LIST,
        value: acceptanceValues.WAIT_LIST,
        label: 'Waitlist',
        description: 'Players registering after filled added to waitlist.',
    },
    {
        id: acceptanceTypeIds.CAPPED_REGISTRATION,
        value: acceptanceValues.CAPPED_REGISTRATION,
        label: 'Capped Registration',
        description: 'Players are not allowed to register after the division is full.',
    },
    {
        id: acceptanceTypeIds.LIST,
        value: acceptanceValues.LIST,
        label: 'Acceptance List',
        description: 'Players are accepted by their rating rather than time of registration.',
    },
];

export const defaultMinimumEntryFee = 5;

export const maxPlayersValue = 8;

export const defaultMaxPlayersValue = 16;

export const noMaximumLabelValue = 2147483647;

export const verifiedAcceptanceMinValue = 4;

export const nonVerifiedAcceptanceMinValue = 1;

export const defaultAcceptanceMinValue = 0;

export const eventQuestionTypes = {
    TEXT: 'text',
    PASSWORD: 'password',
    HOME_COURT: 'home_court',
    PHONE: 'phone',
    EMAIL: 'email',
    MULTIPLE_CHOICE: 'multiple_choice',
    THIRDPARTY_ID: 'thirdParty_id',
};

export const eventQuestionTypeIds = {
    TEXT: 1,
    PASSWORD: 2,
    HOME_COURT: 3,
    PHONE: 4,
    EMAIL: 5,
    MULTIPLE_CHOICE: 6,
    THIRDPARTY_ID: 7,
};

export const registrationGroupStatuses = {
    REGISTERED: 'REGISTERED',
    NEED_PARTNER: 'NEED_PARTNER',
    PENDING: 'PENDING',
    WITHDRAWN: 'WITHDRAWN',
};

export const registrationGroupStatusTypeIds = {
    REGISTERED: 0, // fully registered, both players are in registered state
    NEED_PARTNER: 1, // need partner and admin has to add player to team
    PENDING: 2, // either invited player has to accept or payment is pending
    WITHDRAWN: 3,
};
export const registrationGroupStatusTypes = {
    0: 'REGISTERED',
    1: 'NEED_PARTNER',
    2: 'PENDING',
    3: 'WITHDRAWN',
};

export const WAITLIST_LABEL = 'Waitlist';

export const MAIN_LABEL = 'Main';

export const dateFormat = 'll';

export const defaultDateFormat = 'l';

export const SPLIT_LABEL = 'Split';

export const acceptanceListRoundTypeIds = {
    MAIN: 1,
    QUALIFYING: 2,
};

export const regStepIds = {
    UPGRADE: 'upgrade',
    PASSWORD: 'password',
    DIVISIONS: 'divisions',
    DIVISIONS_ADD: 'divisions-add',
    DIVISIONS_SWITCH: 'divisions-switch',
    DIVISIONS_CANCEL: 'divisions-cancel',
    TEAMMATE: 'teammate',
    QUESTIONS: 'questions',
    CONFIRM: 'confirm',
    PAYMENT: 'payment',
    PAYMENT_WAIT: 'payment-wait',
    NCSA_PROMO: 'ncsaPromo',
    NCSA_REG: 'ncsaReg',
    NCSA_FINISH: 'ncsaFinish',
    CAMP_USER_SELECTION: 'campUserSelection',
    CAMP_DIVISION_SELECTION: 'campDivisionSelection',
    CAMP_CONFIRM: 'camp-confirm',
    CAMP_QUESTIONS: 'camp-questions',
    CHANGE_PARTNER: 'changePartner',
};

export const registrationUserOptions = {
    SINGLE_PLAYER: 'single',
    MULTIPLE_PLAYERS: 'multiple',
};

export const eventFlows = {
    CAMP_FLOW: 'camp_flow',
    CHANGE_PARTNER: 'changePartner',
};

export const sidebarMessages = {
    PAYMENT_PROCESSING: 'Please wait while payment is processing',
};

export const gameTypeValues = {
    SINGLES: 'singles',
    DOUBLES: 'doubles',
};

export const playerActionOptions = {
    ADD_PARTNER: 'add_partner',
    REFUND: 'refund',
    MESSAGE: 'message',
    WITHDRAW: 'withdraw',
    SPLIT: 'split',
    TAG: 'tag',
    SPECIAL_EXEMPT: 'specialExempt',
    MAIN: 'MAIN',
    QUALIFYING: 'QUALIFYING',
    ALTERNATE: 'ALTERNATE',
    REMOVE: 'remove',
    WAITLIST_MOVE_TO_MAIN: 'waitlistMoveToMain',
};

export const usapDefaultQuestion = 'Enter your USA Pickleball member ID';

export const usapDefaultDescription = 'This required field was added because you elected to make this a USA Pickleball sanctioned event.';

export const flexLeagueHomeCourtQuestion = 'Enter or edit your home court location.';

export const flexLeagueHomeCourtDescription = 'Your location may be used by the Flex League organizer to match you with level based players who live nearby to minimize travel. This will update your home court in your profile which you can always edit at a later time.';

export const pttTourTags = [
    'ac2a49a9-d7a4-4a5a-8884-c957e1fe23cc', // UTR Pro Tennis Tour (PTT)
    'f33fc7ff-1dea-4b8d-b93e-ba1105256cb3', // Junior Regionals
    'f78b3b43-3400-4412-9865-70fea6e7721a', // Les Petits As
    '31ef13f1-e7c6-4974-9e5b-4b69f8e28dbe', // College Circuits
];

export const pttClubIds = [11313, 12083, 12084];

export const playOffDrawDetails = [
    {
        id: 'ficThreeFourPlayoffDraw',
        fieldName: 'isThreeFourPlayoffDraw',
        name: '3 - 4 playoff draw',
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_CONSOLATION,
        needsExtraFieldsToCheck: false,
        extraFields: null,
    },
    {
        id: 'ficFiveSixPlayoffDraw',
        fieldName: 'isFiveSixPlayoffDraw',
        name: '5 - 6 playoff draw',
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_CONSOLATION,
        needsExtraFieldsToCheck: true,
        extraFields: [{
            id: 'ficFormatTypeIdFiveSixPlayoffDraw',
            name: 'ficFormatTypeId',
            value: ficFormats.FIC_QF,
        }],
    },
    {
        id: 'roundRobinPlayoffDraw',
        fieldName: 'createPlayoffDraw',
        name: 'playoff draw',
        drawEliminationTypeId: drawEliminationTypeIds.ROUND_ROBIN,
        needsExtraFieldsToCheck: false,
    },
    {
        id: 'singleEliminationPlayoffDraw',
        fieldName: 'createPlayoffBronzeMatch',
        name: '3-4 playoff draw',
        drawEliminationTypeId: drawEliminationTypeIds.SINGLE_ELIMINATION,
        needsExtraFieldsToCheck: true,
        extraFields: [{
            name: 'drawSize',
            value: 2,
        }],
    },
    {
        id: 'addHocPlayoffDraw',
        fieldName: 'createPlayoffDraw',
        name: 'playoff draw',
        drawEliminationTypeId: drawEliminationTypeIds.AD_HOC,
        needsExtraFieldsToCheck: false,
    },
    {
        id: 'fibThreeFourPlayoffDraw',
        fieldName: 'createPlayoffBronzeMatch',
        name: '3 - 4 playoff draw',
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_BACK_DRAW,
        needsExtraFieldsToCheck: false,
        extraFields: null,
    },
];

export const playOffDrawDetailsForAutomatedDraws = [
    {
        id: 'roundRobinPlayoffDraw',
        fieldName: 'createPlayoffDraw',
        name: 'playoff draw(s) for group winners',
        drawEliminationTypeId: drawEliminationTypeIds.ROUND_ROBIN,
        needsExtraFieldsToCheck: true,
        extraFields: [{
            name: 'autofillTypeId',
            value: drawAutofillTypeIds.LEVEL_BASED,
        }],
    },
];

const ficScoringTypeOverrides = [
    {
        id: 'ficConsolationDrawOverride',
        name: 'consolation',
        categoryTypeId: drawCategoryTypeIds.CONSOLATION,
        isFinalRound: false,
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_CONSOLATION,
    },
    {
        id: 'ficFinalsOverride',
        name: 'finals',
        categoryTypeId: drawCategoryTypeIds.MAIN,
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_CONSOLATION,
    },
    {
        id: 'ficThreeFourPlayoffDrawOverride',
        name: '3 - 4 playoff',
        categoryTypeId: drawCategoryTypeIds.THREEFOURPLAYOFF,
        isForPlayOffDraw: true,
        isFinalRound: false,
        playOffDrawFieldName: 'isThreeFourPlayoffDraw',
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_CONSOLATION,
    },
    {
        id: 'ficFiveSixPlayoffDrawOverride',
        name: '5 - 6 playoff',
        categoryTypeId: drawCategoryTypeIds.FIVESIXPLAYOFF,
        isForPlayOffDraw: true,
        isFinalRound: false,
        playOffDrawFieldName: 'isFiveSixPlayoffDraw',
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_CONSOLATION,
    },
];

const doubleEliminationScoringTypeOverrides = [
    {
        id: 'doubleEliminationBackDrawOverride',
        name: 'backdraw',
        categoryTypeId: drawCategoryTypeIds.BACK_DRAW,
        isFinalRound: false,
        drawEliminationTypeId: drawEliminationTypeIds.DOUBLE_ELIMINATION,
    },
    {
        id: 'doubleEliminationMainDrawFinalsOverride',
        name: 'Gold / Silver',
        categoryTypeId: drawCategoryTypeIds.MAIN,
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.DOUBLE_ELIMINATION,
    },
    {
        id: 'doubleEliminationBackDrawFinalsOverride',
        name: 'Bronze',
        categoryTypeId: drawCategoryTypeIds.BACK_DRAW,
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.DOUBLE_ELIMINATION,
    },
];

const singleEliminationScoringTypeOverrides = [
    {
        id: 'singleEliminationFinalsOverride',
        name: 'Finals',
        categoryTypeId: drawCategoryTypeIds.MAIN,
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.SINGLE_ELIMINATION,
    },
    {
        id: 'singleEliminationPlayoffFinalsOverride',
        name: 'Finals',
        categoryTypeId: drawCategoryTypeIds.AUTO_PLAYOFF,
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.SINGLE_ELIMINATION,
    },
    {
        id: 'singleEliminationBronzePlayoffOverride',
        name: '3-4 playoff',
        categoryTypeId: drawCategoryTypeIds.THREEFOURPLAYOFF,
        isFinalRound: false,
        drawEliminationTypeId: drawEliminationTypeIds.SINGLE_ELIMINATION,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffBronzeMatch',
    },
];

const firstMatchBackDrawScoringTypeOverrides = [
    {
        id: 'firstMatchBackDrawBackDrawOverride',
        name: 'backdraw',
        categoryTypeId: drawCategoryTypeIds.BACK_DRAW,
        isFinalRound: false,
        drawEliminationTypeId: drawEliminationTypeIds.FIRST_MATCH_BACKDRAW,
    },
    {
        id: 'firstMatchBackDrawFinalsOverride',
        name: 'Finals',
        categoryTypeId: drawCategoryTypeIds.MAIN,
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.FIRST_MATCH_BACKDRAW,
    },
];

const roundRobinScoringTypeOverrides = [
    {
        id: 'roundRobinPlayoffDrawOverride',
        name: 'playoff',
        categoryTypeId: drawCategoryTypeIds.AUTO_PLAYOFF,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffDraw',
        isFinalRound: false,
        drawEliminationTypeId: drawEliminationTypeIds.ROUND_ROBIN,
    },
    {
        id: 'roundRobinPlayoffDrawFinalsOverride',
        name: 'gold medal',
        categoryTypeId: drawCategoryTypeIds.AUTO_PLAYOFF,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffDraw',
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.ROUND_ROBIN,
    },
    {
        id: 'roundRobinPlayoffDrawBronzeOverride',
        name: 'bronze medal',
        categoryTypeId: drawCategoryTypeIds.THREEFOURPLAYOFF,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffBronzeMatch',
        drawEliminationTypeId: drawEliminationTypeIds.ROUND_ROBIN,
    },
];

const adHocScoringTypeOverrides = [
    {
        id: 'adHocPlayoffDrawOverride',
        name: 'playoff',
        categoryTypeId: drawCategoryTypeIds.AUTO_PLAYOFF,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffDraw',
        isFinalRound: false,
        drawEliminationTypeId: drawEliminationTypeIds.AD_HOC,
    },
    {
        id: 'adHocPlayoffDrawFinalsOverride',
        name: 'gold medal',
        categoryTypeId: drawCategoryTypeIds.AUTO_PLAYOFF,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffDraw',
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.AD_HOC,
    },
    {
        id: 'adHocPlayoffDrawBronzeOverride',
        name: 'bronze medal',
        categoryTypeId: drawCategoryTypeIds.THREEFOURPLAYOFF,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffBronzeMatch',
        drawEliminationTypeId: drawEliminationTypeIds.AD_HOC,
    },
];

const feedInBackDrawScoringTypeOverrides = [
    {
        id: 'feedInBackDrawBackDrawOverride',
        name: 'backdraw',
        categoryTypeId: drawCategoryTypeIds.BACK_DRAW,
        isFinalRound: false,
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_BACK_DRAW,
    },
    {
        id: 'feedInBackDrawFinalsOverride',
        name: 'Finals',
        categoryTypeId: drawCategoryTypeIds.MAIN,
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_BACK_DRAW,
    },
    {
        id: 'feedInBackDrawBronzePlayoffOverride',
        name: '3-4 playoff',
        categoryTypeId: drawCategoryTypeIds.THREEFOURPLAYOFF,
        isFinalRound: false,
        drawEliminationTypeId: drawEliminationTypeIds.FEED_IN_BACK_DRAW,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffBronzeMatch',
    },
];

export const scoringTypeOverrides = [
    ...firstMatchBackDrawScoringTypeOverrides,
    ...singleEliminationScoringTypeOverrides,
    ...ficScoringTypeOverrides,
    ...doubleEliminationScoringTypeOverrides,
    ...roundRobinScoringTypeOverrides,
    ...adHocScoringTypeOverrides,
    ...feedInBackDrawScoringTypeOverrides,
];

const automatedRoundRobinScoringTypeOverrides = [
    {
        id: 'roundRobinPlayoffDrawOverride',
        name: 'playoff',
        categoryTypeId: drawCategoryTypeIds.AUTO_PLAYOFF,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffDraw',
        isFinalRound: false,
        drawEliminationTypeId: drawEliminationTypeIds.ROUND_ROBIN,
    },
    {
        id: 'roundRobinPlayoffDrawFinalsOverride',
        name: 'gold medal',
        categoryTypeId: drawCategoryTypeIds.AUTO_PLAYOFF,
        isForPlayOffDraw: true,
        playOffDrawFieldName: 'createPlayoffDraw',
        isFinalRound: true,
        drawEliminationTypeId: drawEliminationTypeIds.ROUND_ROBIN,
    },
    {
        id: 'roundRobinPlayoffDrawBronzeOverride',
        name: 'bronze medal',
        categoryTypeId: drawCategoryTypeIds.THREEFOURPLAYOFF,
        isForPlayOffDraw: true,
        isFinalRound: false,
        playOffDrawFieldName: 'createPlayoffBronzeMatch',
        drawEliminationTypeId: drawEliminationTypeIds.ROUND_ROBIN,
    },
];

export const scoringTypeOverridesForAutomatedDraws = [
    ...automatedRoundRobinScoringTypeOverrides,
];

export const automatedDrawTypeDetails = [
    {
        id: 1,
        primaryKey: 'eliminationTypeId',
        primaryValue: drawEliminationTypeIds.ROUND_ROBIN,
        needsSecondaryKey: true,
        secondaryKey: 'autofillTypeId',
        secondaryValue: drawAutofillTypeIds.SEEDED,
        pointsToDisplay: [
            'Top players seeded across groups',
            'Remaining players randomly selected',
            '# groups = # of seeds',
        ],
    },
    {
        id: 2,
        primaryKey: 'eliminationTypeId',
        primaryValue: drawEliminationTypeIds.ROUND_ROBIN,
        needsSecondaryKey: true,
        secondaryKey: 'autofillTypeId',
        secondaryValue: drawAutofillTypeIds.SNAKE,
        pointsToDisplay: [
            'Top players split across groups',
            'Players filled in snake-like order',
            'Closest UTR average across groups',
        ],
    },
    {
        id: 3,
        primaryKey: 'eliminationTypeId',
        primaryValue: drawEliminationTypeIds.ROUND_ROBIN,
        needsSecondaryKey: true,
        secondaryKey: 'autofillTypeId',
        secondaryValue: drawAutofillTypeIds.LEVEL_BASED,
        pointsToDisplay: [
            'Players placed into groups with others closest to their UTR Rating',
            'Draw size determined by the number of guaranteed matches',
            'Most competitive experience for players',
        ],
    },
    {
        id: 4,
        primaryKey: 'eliminationTypeId',
        primaryValue: drawEliminationTypeIds.FLEX_LEAGUE,
        needsSecondaryKey: false,
        pointsToDisplay: [
            'The Flex League draw type is an ad-hoc format for 5-10 players, with four unique matches for each player in the league session. Matches must be played to best two out of three with a 10-point',
        ],
    },
];

export const getPlayersCountListToForwardForPlayoff = (minCount = 1, maxCount = 2) => {
    let startingCount = minCount;
    const list = [];
    while (startingCount <= maxCount) {
        list.push({
            label: startingCount,
            value: startingCount,
        });

        startingCount *= 2;
    }

    return list;
};

export const playerListDataTypes = {
    DRAWS: 'draws',
    DIVISIONS: 'divisions',
};

export const getPlayersCountListToForwardForAutomatedPlayoff = (minCount = 1, maxCount = 2) => {
    let startingCount = minCount;
    const list = [];
    while (startingCount <= maxCount) {
        list.push({
            label: startingCount,
            value: startingCount,
        });

        startingCount += 1;
    }

    return list;
};

export const medalNames = {
    1: 'Gold',
    2: 'Silver',
    3: 'Bronze',
};

export const PreRegInviteStatuses = {
    CREATED: 1,
    SENT: 2,
    REGISTERED: 3,
    DECLINED: 4,
    EXPIRED: 5,
};

export const groupSmsCodes = {
    SUCCESS: true,
    FAILED: false,
};

export const MaximumMedalsToDisplay = 3;

export const MaximumPreRegInvitesPerPage = 100;
export const MinimumNumberOfPages = 1;

export const tmsEventDrawTagIds = {
    Qualifier: 1,
    LuckyLoser: 2,
    Alternate: 3,
    WildCard: 4,
    Withdrawn: 5,
    Retired: 6,
    Defaulted: 7,
};

export const MATCHES_GUARANTEED_FLEX_LEAGUE = 4;

export const AllowedBucketTypesForMovingToMain = [
    acceptanceBucketTypeSortKey.QUALIFYING,
    acceptanceBucketTypeSortKey.ALTERNATE,
];

export const AllowedBucketTypesForMovingToQualifying = [
    acceptanceBucketTypeSortKey.ALTERNATE,
    acceptanceBucketTypeSortKey.MAIN,
];

export const AllowedBucketTypesForMovingToAlternate = [
    acceptanceBucketTypeSortKey.MAIN,
];

export const AllowedBucketTypesForTagging = [
    acceptanceBucketTypeSortKey.MAIN,
    acceptanceBucketTypeSortKey.QUALIFYING,
    acceptanceBucketTypeSortKey.ALTERNATE,
];

export const AllowedBucketTypesForWithdrawing = [
    acceptanceBucketTypeSortKey.MAIN,
    acceptanceBucketTypeSortKey.QUALIFYING,
    acceptanceBucketTypeSortKey.ALTERNATE,
];

export const ANNUAL_POWER_ONLY_LABEL = 'Annual Power Only';

export const maxTitleLength = 75;
